export const ADD_ROW = 'ADD_ROW'
export const ENTER_EDIT = 'ENTER_EDIT'
export const CANCEL_EDIT = 'CANCEL_EDIT'
export const CANCEL_DELETE = 'CANCEL_DELETE'
export const UPDATE_FIELD = 'UPDATE_FIELD'
export const TOGGLE_CONFIRM_DELETE = 'TOGGLE_CONFIRM_DELETE'



// WEBPACK FOOTER //
// ./src/pages/community-config/community-grid/constants.ts